import { render, staticRenderFns } from "./ShowRegisterInfo.vue?vue&type=template&id=6cff7362&scoped=true&"
import script from "./ShowRegisterInfo.vue?vue&type=script&lang=js&"
export * from "./ShowRegisterInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cff7362",
  null
  
)

export default component.exports